<template>
  <div class="modal-body-contato">
    <div
      class="contato-modal-container base animate__animated animate__bounceInDown animate__delay-0.5s"
    >
      <div class="contato-modal-close">
        <CloseIcon @action="closeModal" />
      </div>
      <div class="contato-modal-container1">
        <v-row>
          <v-col cols="12">
            <label class="input-labels">{{
              $t("registrations.producers.order")
            }}</label>
            <v-text-field
              hide-details
              v-model="contatoEdit.ordem"
              solo
              class="contato-textinput"
              :placeholder="$t('registrations.producers.insert-contact-order')"
              type="number"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <label class="input-labels">{{
              $t("registrations.producers.description")
            }}</label>
            <v-autocomplete
              hide-details
              v-model="contatoEdit.descricao"
              solo
              :items="['E-mail', 'Telefone', 'WhatsApp']"
              class="textinput"
              :placeholder="
                $t('registrations.producers.insert-contact-description')
              "
              type="text"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <label class="input-labels">{{
              $t("registrations.producers.text")
            }}</label>
            <v-text-field
              hide-details
              v-model="contatoEdit.texto"
              solo
              class="contato-textinput"
              :placeholder="$t('registrations.producers.insert-contact-text')"
              type="text"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <!-- <div class="contato-modal-container7"> -->
        <v-row class="justify-end pa-3">
          <v-btn
            height="48"
            class="order-2 button btn-border btn-right"
            @click="saveContato()"
          >
            {{ $t("registrations.save") }}
          </v-btn>

          <v-btn
            height="48"
            class="btn-save"
            color="transparent"
            elevation="0"
            @click="closeModal()"
          >
            {{ $t("registrations.cancel") }}
          </v-btn>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactDialog",
  components: {
    CloseIcon: () => import("@/components/icons/CloseIcon.vue"),
  },
  props: ["contatoEdit", "contatoIdx"],
  data() {
    return {};
  },
  methods: {
    saveContato() {
      if (
        this.$loja_gerenciar.cadastro.configuracoes_adicionais
          .configsPlusAddEdit == "new"
      ) {
        this.$loja_gerenciar.cadastro.configuracoes_adicionais.contato.push({
          ordem: this.contatoEdit.ordem,
          titulo: this.contatoEdit.descricao,
          valor: this.contatoEdit.texto,
        });

        this.contatoEdit.ordem = "";
        this.contatoEdit.descricao = "";
        this.contatoEdit.texto = "";

        document.getElementsByClassName("modal-body-contato")[0].style.display =
          "none";
      } else {
        this.$loja_gerenciar.cadastro.configuracoes_adicionais.contato[
          this.contatoIdx
        ].ordem = this.contatoEdit.ordem;
        this.$loja_gerenciar.cadastro.configuracoes_adicionais.contato[
          this.contatoIdx
        ].titulo = this.contatoEdit.descricao;
        this.$loja_gerenciar.cadastro.configuracoes_adicionais.contato[
          this.contatoIdx
        ].valor = this.contatoEdit.texto;

        document.getElementsByClassName("modal-body-contato")[0].style.display =
          "none";
      }
    },
    closeModal() {
      document.getElementsByClassName("modal-body-contato")[0].style.display =
        "none";
      this.contatoEdit.ordem = "";
      this.contatoEdit.descricao = "";
      this.contatoEdit.texto = "";
    },
  },
};
</script>

<style scoped>
.modal-body-contato {
  display: none;
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 888;
  /* Sit on top */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  overflow: auto;
  /* Enable scroll if needed */
  background-color: rgb(204, 94, 94);
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4);
  /* Black w/ opacity */
  justify-content: center;
  align-items: center;
}

.contato-modal-container {
  width: 650px;
  max-height: 850px;
  display: flex;
  position: relative;
  align-items: center;
  padding: 0.0825rem;
  border-radius: 1.365rem;
  /* padding-left: 20px; */
  /* border-radius: 20px; */
  /* padding-right: 20px; */
  /* padding-bottom: 20px; */
  flex-direction: column;
  justify-content: flex-start;
  background-color: #eaeaea;
}

.contato-modal-close {
  width: 100%;
  height: 5%;
  display: flex;
  justify-content: flex-end;
  padding: 0.325rem;
}

.contato-modal-container1 {
  width: 100%;
  height: 85%;
  padding: 1rem;
  /* flex: 0 0 auto; */
  /* display: flex;
        align-items: center; */
  /* padding-right: 15px;
        padding-top: 15px;
        padding-bottom: 15px; */
  /* flex-direction: row;
        justify-content: flex-start; */
}

.contato-textinput {
  width: 100%;
  height: 51;
  border-radius: 10px;
  margin-top: 6px;
}
</style>
